import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles} from '../../../../utils/styles';

const StyledSpending = styled(Space)`
  ${bordersStyles.default};

  background-color: ${props => props.theme.colors.neutral_1};
  padding: 24px;
  position: relative;
  width: 100%;

  & > .ant-space-item {
    width: 100%;
  }
`;

const StyledSpendingHeader = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export {
  StyledSpending,
  StyledSpendingHeader,
}
